import React from 'react';
import { Check } from 'lucide-react';

interface CheckboxProps {
  label: string | React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
}

const Checkbox = ({ label, checked, onChange, className, style = {}, disabled = false }: CheckboxProps) => {
  return (
    <label
      className={`flex items-center gap-3 text-zinc-400 ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'} ${className}`}
      style={style}
    >
      <div className="relative">
        <input
          type="checkbox"
          className="hidden"
          checked={checked}
          disabled={disabled}
          onChange={() => !disabled && onChange(!checked)}
        />
        <div
          className={`w-6 h-6 border border-1 rounded border-zinc-600 flex items-center justify-center`}
        >
          {checked && <Check strokeWidth={3} color={'white'} size={16} />}
        </div>
      </div>
      <span>{label}</span>
    </label>
  );
};

export default Checkbox;
